<div
    [matTooltip]="tooltip || null"
    *ngIf="(numberOfNotifications$ | async) >= 0"
    [@fadeInOut]
    [class.sb-icon-badge]="isIconBadge"
>
    <sb-animated-number
        [style.opacity]="isLoading ? 0 : 1"
        maximumFractionDigits="0"
        minimumFractionDigits="0"
        [value]="numberOfNotifications$ | async"
        [formatStyle]="style"
        [suffix]="suffix"
    ></sb-animated-number>
    <div *ngIf="isLoading" [@fadeInOut]>
        <sb-pending-button-indicator state="loading"></sb-pending-button-indicator>
    </div>
</div>
